import { Component, OnInit, Injector, Input,ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from "../../base.component";
import { intersection, isArray } from 'lodash';
import { find, isEmpty } from 'lodash';

@Component ({
    selector: 'more-button',
    encapsulation: ViewEncapsulation.None,

    template:`
    <div class="wrapper" tabindex="0" (keypress)="$event.key == 'Enter' ? toggle($event) : false">
      <div class="btn more {{mode}}"
           tabindex="-1" 
           (click)="toggle($event)"
           [ngClass]="{'active': isMoreOpen, 'more-selected': isMoreSelected(), disabled: isDisabled }"
           [attr.numberOfSelected]="numOfHiddenSelected">
 
        <span class="sm-label">
         {{ title }}
        </span>
      </div>
    </div>

    `,
    styleUrls: ['./more-button.component.scss']

})

export class MoreButtonComponent extends BaseComponent implements OnInit   {
   @Input() mode: any;
   @Input() title: string;
   @Input() options: any;
   @Input() selected: any;
   @Input() arrOffset: any;
   @Input() isDisabled: boolean;
   @Input() isMoreOpen : boolean;
   @Output() isOpen: EventEmitter<boolean> = new EventEmitter();
   numOfHiddenSelected: any;


    constructor(injector : Injector) {
        super(injector)
   }

   ngOnInit() {
    this.numOfHiddenSelected = this.getNumOfHiddenSelected();
   }

   toggle(event) {
    if (this.isDisabled) {
      return;
    }

     const keys = ["Enter", " ", "Spacebar"];
    // handles regular click & tabbing
     if (event.type === 'click' || (event.type === "keypress" && keys.indexOf(event.key) > -1)) {
       event.target.blur();
      this.isOpen.emit();
      this.isMoreOpen =!this.isMoreOpen;
      event.preventDefault();
      event.preventDefault ? event.preventDefault() : (event.returnValue = false);
      event.stopPropagation();
      event.stopImmediatePropagation();

    }
  }

  isMoreSelected() {
  const isSelected = this.isSelected();
  return this.mode == 'radio' ? !isEmpty(isSelected) : isSelected >  0;
      }

      isSelected() {
    if(!isEmpty(this.selected)){
    const offsetOptions = this.options.slice(this.arrOffset);
    const selectedValues = isArray(this.selected)
      ? this.selected
      : [this.selected];

      if(this.mode == 'radio'){
        var selected = find(offsetOptions, { 'value' : selectedValues[0] });
        return selected;
      }
      if(this.mode == 'multi'){
        return intersection(offsetOptions.map(({ value }) => value), selectedValues).length;
      }
    }
  }

  getNumOfHiddenSelected() {
    if(!isEmpty(this.selected)){
    const offsetOptions = this.options.slice(this.arrOffset);
    const selectedValues = isArray(this.selected)
      ? this.selected
      : [this.selected];
      return intersection(offsetOptions.map(({ value }) => value), selectedValues).length;
    }
  }
}

